/**
 * Channel enum for runtime usage
 */
export const ChannelEnum = {
    SMS: 'SMS',
    EMAIL: 'EMAIL',
    CALL: 'CALL',
};
/** The same values as a tuple, for schemas that enumerate them. */
export const CHANNEL_VALUES = [
    'CALL',
    'EMAIL',
    'SMS',
];
/**
 * MessageDirection enum for runtime usage
 */
export const MessageDirectionEnum = {
    INBOUND: 'INBOUND',
    OUTBOUND: 'OUTBOUND',
};
export const SessionStatusEnum = {
    ACTIVE: 'ACTIVE',
    ENDED: 'ENDED',
    RESOLVED: 'RESOLVED',
    ESCALATED: 'ESCALATED',
};
export const SessionOutcomeEnum = {
    RESOLVED: 'RESOLVED',
    ESCALATED: 'ESCALATED',
    ABANDONED: 'ABANDONED',
    FAILED: 'FAILED',
    UNKNOWN: 'UNKNOWN',
};
//# sourceMappingURL=session.js.map